<template>
  <div class="goods">
    <van-swipe class="goods-swipe" :autoplay="3000">
      <van-swipe-item v-for="thumb in images.thumb" :key="thumb">
        <img :src="thumb" >
      </van-swipe-item>
    </van-swipe>
    <Bottom></Bottom>
  </div>
</template>

<script>
  import {Swipe,SwipeItem,Grid,GridItem,Icon} from 'vant';
  import { mapState, mapMutations } from "vuex";
  import Bottom from '../bottom/index.vue';
  export default {
    components: {
      Bottom,
      [Swipe.name]: Swipe,
      [SwipeItem.name]: SwipeItem,
      [Grid.name]: Grid,
      [GridItem.name]: GridItem,
      [Icon.name]: Icon,
    },
    data() {
      return {
        images: {
          thumb: [
            '/img/1.jpg',
            '/img/2.jpg',
            '/img/3.jpg',
            '/img/6.jpg'
          ]
        }
      };
    },
    methods: {
    ...mapMutations(["changePermissionAgent", "changeDefaultAgentIndex"]),

    },
    computed: {
    ...mapState(["permissionAgent", "defaultAgentIndex"]),
    },
    created() {
      this.$http.post('consumable/inventory/mainList',{
        projectErpCode:'123'
      }).then(function (response) {
        window.console.log(response);

      })
    }
  };
</script>

<style lang="less">
.goods {
    &-swipe {
        height:5rem;
        img {
            width: 100%;
            
            display: block;
        }
    }
}


</style>
